import { render } from "./ImproveYourProfile.vue?vue&type=template&id=61aa15fe&ts=true"
import script from "./ImproveYourProfile.vue?vue&type=script&lang=ts"
export * from "./ImproveYourProfile.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__